<template>
<div class="slide-cooker">
  <template v-if="!loading">
    <div class="page__header">
      <div class="page__wrap">
        <div class="search-question" data-step="5">Your chosen cooker</div>
        <h2>{{ cooker.attributes.productName}} {{cooker.attributes.size}} CM {{ fromShortcode(cooker.attributes.fuel) }}</h2>
        <div class="text__brochure" v-html="cooker.attributes.brochureDescription"></div>
        </div>
    </div>
    <div class="page__content">
      <div class="page__wrap">
        <div class="flex__wrapper">
          <div class="info__image">
            <img :src="cooker.variations[selectedVariation].img"/>
          </div> 
          <div class="info__colours">
            <div class="colour-wrap">
              <div 
              class="colour-blob"
              v-for="(variation, idx) in cooker.variations"
              :key="idx"
              @click="setVariation(idx)"
              :class="setColourBlobClasses(idx)"
              :style="{ 
                backgroundColor: '#' + variation.colorCode, 
                color: (useWhiteText(variation.colorCode) ? '#FFFFFF' : '#000000') 
              }">
                <span>{{variation.color}}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="flex__wrapper">
          <div class="info__text">
            <ul class="info__features">
              <li v-for="feature in cooker.attributes.features" :key="feature.id">{{feature.featureName}}</li>
            </ul>
            <ul class="info__attr">
              <li><strong>Left-hand Oven:</strong> {{cooker.attributes.leftOvenDescription}}</li>
              <li v-if="cooker.attributes.rightOvenDescription"><strong>Right-hand Oven:</strong> {{cooker.attributes.rightOvenDescription}}</li>
              <li><strong>JBA Code:</strong> {{cooker.variations[selectedVariation].JBA_CODE}}</li>
            </ul>
          </div>
          <div class="info__button">
            <button type="button" class="hood-button" @click="toggleHoodModal" v-show="showHoodsButton">
              <img src="static/cooker-hood-icon.png" alt="Cooker Hood" />
              Find your Matching Hood
            </button>
            <button type="button" class="back-button" @click="goBackToResults">
              <i class="fas fa-arrow-left"></i>
              Back to Results
            </button>
          </div>
        </div>
      </div>
      <hood-modal :cooker="cooker.id" v-if="showHoodsModal" @click="toggleHoodModal"></hood-modal>
  </div>
  </template>
</div>
</template>

<script>
import { fromShortcode } from "../../api/fuel.js";
import { getDatabase } from "../../api/index";
import { useWhiteText } from "../../api/contrastCheck";
export default {
  methods: {
    useWhiteText,
    fromShortcode,
    setVariation(idx) {
      this.selectedVariation = idx;
    },
    goBackToResults() {
      this.$router.push({ name: "results", params: this.$route.params });
    },
    toggleHoodModal(){
      this.showHoodsModal = !this.showHoodsModal;
    },
    setColourBlobClasses(idx){
      let centerVariation = Math.round((this.cooker.variations.length - 1) / 2);

      return {
        __selected: this.selectedVariation == idx,
        left: idx < centerVariation,
        center: idx == centerVariation && (centerVariation % 2) == 1,
        right: idx > centerVariation || idx >= centerVariation && (centerVariation % 2) == 0
      };
    }
  },
  data: function() {
    return {
      selectedVariation: 0,
      loading: true,
      cooker: null,
      showHoodsModal: false,
      showHoodsButton: false
    };
  },
  mounted() {
    this.$ga.screenview('cooker');
  
    getDatabase()
      .get(this.$route.params.cooker)
      .then(cooker => {
        this.cooker = cooker;
        this.loading = false;
      });
    getDatabase()
    .getCookerHoodsFor(this.$route.params.cooker)
    .then( d => {
      this.showHoodsButton = d.length > 0;
    })
  },
  watch: {
    "$route.params": function() {
      getDatabase()
        .get(this.$route.params.cooker)
        .then(cooker => {
          this.cooker = cooker;
          this.loading = false;
        });
      getDatabase()
    .getCookerHoodsFor(this.$route.params.cooker)
    .then( d => {
      this.showHoodsButton = d.length > 0;
    })
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/pages/slide-6-cooker.vue